export default {
  moneyoutAction: {
    id: 'dashboard_others_credit_card_action',
    defaultMessage: 'Transfer my credit to my bank account',
  },
}
